
import { useNavigate } from 'react-router-dom';
import '../cta/CTA.css'
import React from 'react';

export default function CTAHome({ id }) {

    const navigate = useNavigate()

    const handleMouseEnter = () => {
        document.querySelectorAll(`#${id} .box`).forEach((box) => box.classList.add('hovered'));
        document.querySelectorAll(`#${id} .box1`).forEach((box) => box.classList.add('hovered'));
        document.querySelectorAll(`#${id} .box2`).forEach((box) => box.classList.add('hovered'));
    };

    const handleMouseLeave = () => {
        document.querySelectorAll(`#${id} .box`).forEach((box) => box.classList.remove('hovered'));
        document.querySelectorAll(`#${id} .box1`).forEach((box) => box.classList.remove('hovered'));
        document.querySelectorAll(`#${id} .box2`).forEach((box) => box.classList.remove('hovered'));
    };




    return (
        <div className="flex flex-col justify-center items-center w-full pb-20 ">
            <div className='w-[90%] md:w-[80%] xl:w-3/5 flex flex-col justify-center items-center rounded-3xl bg-tealGreen h-72 font-sans  relative magic' onMouseEnter={() => handleMouseEnter()}
                onMouseLeave={() => handleMouseLeave()}>
                <div className='box rounded-3xl' id={id}></div>
                <div className='box1 rounded-3xl' id={id}></div>
                <div className='box2 rounded-3xl' id={id}></div>
                <div className="flex relative z-40 w-full max-h-full items-center overflow-hidden flex-row gap-2">
                    <div className=" flex flex-col gap-4 basis-[50%] w-[50%] pl-10">
                        <p className='z-40 text-white leading-10 mb-4 font-pop font-medium text-2xl md:text-4xl magic'>Forward to the future with Paycott</p>
                        <button
                            className='z-40 shadow-md font-medium text-lg border-gray-200 border-2 hover:bg-gray-300 h-12 w-2/3 bg-white rounded-full magic'
                            onClick={() => {
                                navigate('/signup')
                            }}
                        >
                            Get Started
                        </button>
                    </div>
                    <div className="w-[50%] basis-[50%] overflow-hidden self-end flex flex-col">
                        <img src="../Assets/Banner/CTAImg.png" alt="" className='w-[90%] object-cover self-end' />
                    </div>
                </div>
            </div>

        </div>
    )
}

